import { MouseClickRightSvg } from "@lhd/assets";
import { COLUMN_TYPE_SETTING } from "@lhd/constants";
import { IData } from "./hook";

export const useColumns = () => {
  return [
    {
      columnId: "index",
      label: "No.",
      type: "text",
      width: 60,
      editable: false,
      icon: <></>,
      resizable: true,
      reorderable: true,
    },
    {
      columnId: "first_name",
      label: "姓",
      type: "text",
      width: 200,
      icon: <></>,
      resizable: true,
      reorderable: true,
    },
    {
      columnId: "last_name",
      label: "名",
      type: "text",
      width: 200,
      icon: <></>,
      resizable: true,
      reorderable: true,
    },
    {
      columnId: "name_start_date",
      label: "姓名の開始日",
      type: "dateTimeCustom",
      width: 180,
      icon: <></>,
      resizable: true,
      reorderable: true,
      tooltip:
        "①BizTreasureでは、時間軸を持っており、\n変更履歴(時期)により表記が変更します\n②新規登録の際は入社日で問題ありません",
      maxWidthTooltip: 260,
    },
    {
      columnId: "working_type",
      label: "契約種別 ",
      type: "text",
      width: 250,
      icon: <MouseClickRightSvg />,
      resizable: true,
      reorderable: true,
      tooltip:
        "左にあるカテゴリーボタン\n簡単抽出可能になります\n契約種別の追加も可能",
      maxWidthTooltip: 170,
    },
    {
      columnId: "registration_number",
      label: "スタッフ番号",
      type: "text",
      width: 200,
      icon: <></>,
      resizable: true,
      reorderable: true,
      tooltip: "BizTreasure管理する\nスタッフ番号を採番\nユニーク(唯一)で登録",
      maxWidthTooltip: 150,
    },
    {
      columnId: "onboarding_start_date",
      label: "契約種別・スタッフ番号の開始日",
      type: "dateTimeCustom",
      width: 350,
      icon: <></>,
      resizable: true,
      reorderable: true,
    },
  ];
};

export const REQUIRED_FIELDS = [
  "first_name",
  "last_name",
  "name_start_date",
  "working_type",
  "registration_number",
  "onboarding_start_date",
];
export const FILTER_FIELDS = [
  "first_name",
  "last_name",
  "name_start_date",
  "working_type",
  "registration_number",
  "onboarding_start_date",
];
export const DATE_FIELDS = ["name_start_date", "onboarding_start_date"];
export const columnTypeValueMap = Object.fromEntries(
  COLUMN_TYPE_SETTING.map((item) => [item.type, item.value]),
);
export const defaultInitialValues = {
  id: undefined,
  first_name: "",
  last_name: "",
  name_start_date: null,
  working_type: "",
  registration_number: "",
  onboarding_start_date: null,
};
export const ERROR_MESSAGES: { [key: string]: string } = {
  save_error: "保存に失敗しました。",
  general: "必須項目を入力してください。",
  first_name: "姓を入力してください。",
  last_name: "名を入力してください。",
  name_start_date: "姓名の開始日を入力してください。",
  working_type: "契約種別が正しくありません。",
};

export const handleData = (data: IData[]) => {
  return [
    ...data,
    ...Array.from(Array(data.length > 100 ? 0 : 100 - data.length).keys()).map(
      (idx) => ({
        id: undefined,
        first_name: "",
        last_name: "",
        name_start_date: null,
        working_type: "",
        registration_number: "",
        onboarding_start_date: null,
      }),
    ),
  ];
};
export const checkInvalidValue = (value: any) => {
  if (value === null || value === undefined) {
    return true;
  }
  if (typeof value === "string" && !value.trim()) {
    return true;
  }
  if (typeof value === "number" && isNaN(value)) {
    return true;
  }
  if (value instanceof Date && isNaN(value.getTime())) {
    return true;
  }

  return false;
};

export const reorderArray = (arr: any[], idxs: number[], to: number) => {
  const movedElements = arr.filter((_, idx) => idxs.includes(idx));
  const targetIdx =
    Math.min(...idxs) < to
      ? (to += 1)
      : (to -= idxs.filter((idx) => idx < to).length);
  const leftSide = arr.filter(
    (_, idx) => idx < targetIdx && !idxs.includes(idx),
  );
  const rightSide = arr.filter(
    (_, idx) => idx >= targetIdx && !idxs.includes(idx),
  );
  return [...leftSide, ...movedElements, ...rightSide];
};
